import React from 'react';
import PropTypes from 'prop-types';

import theme from './OOHDay.scss';


const propTypes = {
  day: PropTypes.string.isRequired,
  value: PropTypes.array.isRequired,
};


const OohDay = ({ day, value }) => {
  const [startDay, endDay] = day.split('-');
  return (
    <div key={ day } className={ theme.container }>
      <div className={ theme.left }>
        { startDay }
        { endDay && ` - ${ endDay }` }
      </div>
      <div className={ theme.right }>
        { value.map(item => (
          <div key={ item.start } className={ theme.timeSlot }>
            <span>
              { item.start } - { item.end }
            </span>
          </div>
        )) }
      </div>
    </div>
  );
};

OohDay.propTypes = propTypes;

export default OohDay;
